module.exports = __webpack_public_path__ + "img/understand.1d885cb9.png";